export const EVENT_LIST_TEMPLATE_NAME = 'event';
export const ITINERARY_LIST_TEMPLATE_NAME = 'itinerary';
